/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uFileXML = A4uFileXML;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uFileXML(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    fillRule: "evenodd",
    points: "20 2 20 12 30 12 20 2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M19,14a1,1,0,0,1-1-1V2H7A1,1,0,0,0,6,3V33a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V14Zm7.069,16.752H24.138a.612.612,0,0,1-.59-.344s-1.41-2.4-1.908-3.271c-.6,1.1-1.215,2.213-1.83,3.289a.566.566,0,0,1-.533.325H17.438a.476.476,0,0,1-.406-.725l2.94-4.8L17.1,20.469a.476.476,0,0,1,.407-.723H19.4a.67.67,0,0,1,.584.342l1.8,3.2L23.49,20.1a.67.67,0,0,1,.59-.353h1.786a.476.476,0,0,1,.406.724l-2.83,4.63,3.032,4.926A.476.476,0,0,1,26.069,30.752ZM14.62,29.028a.257.257,0,0,1-.209.408H11.667a.257.257,0,0,1-.206-.1L8,24.718,11.461,20.1a.256.256,0,0,1,.206-.1h2.744a.257.257,0,0,1,.209.407l-3.505,4.31Z"
  }));
}